import { Template, TemplateType_Slug } from '@weave/schema-gen-ts/dist/schemas/messaging/templator/v2/model.pb';
import { createShallowStore, createStoreWithSubscribe } from '@frontend/store';

interface FormsTemplateState {
  selectedMessageTemplate?: Template;
  selectedMessageTemplateType?: TemplateType_Slug;
  setSelectedMessageTemplateType: (type?: TemplateType_Slug) => void;
  setSelectedMessageTemplate: (template?: Template) => void;
}

export const useTemplateMessagingSubscribe = createStoreWithSubscribe<FormsTemplateState>(
  (set) => ({
    selectedMessageTemplate: undefined,
    selectedMessageTemplateType: undefined,

    setSelectedMessageTemplateType: (type) => {
      set({ selectedMessageTemplateType: type });
    },

    setSelectedMessageTemplate: (template) => {
      set({ selectedMessageTemplate: template });
    },
  }),
  {
    name: 'template-messaging-store',
  }
);

export const useTemplateMessagingStore = createShallowStore(useTemplateMessagingSubscribe);
